export var SIZES = {
  SMALL: "small",
  NORMAL: "normal"
};
export var STATES = {
  DEFAULT: "default",
  HOVER: "hover",
  ACTIVE: "active"
};